export const EXCMSLA_DELETE_RESET = 'EXCMSLA_DELETE_RESET'
export const EXCMSLA_DELETE_SET_ERROR = 'EXCMSLA_DELETE_SET_ERROR'
export const EXCMSLA_DELETE_SET_DELETED = 'EXCMSLA_DELETE_SET_DELETED'
export const EXCMSLA_DELETE_TOGGLE_LOADING = 'EXCMSLA_DELETE_TOGGLE_LOADING'
